module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1290.1408e2a0.png";